import { IncError } from "@core/domain/errors/inc.error";
import i18n from "@i18n";

export class ExternalDerivationMapperError extends IncError {
    constructor() {
        super(i18n.t("error:beneficiary.externalDerivation.mapperError"));

        Object.setPrototypeOf(this, ExternalDerivationMapperError.prototype);
    }
}